// extracted by mini-css-extract-plugin
export default {"root":"MenuItem_root__f7RR0","separator":"MenuItem_separator__W+NzV","caption":"MenuItem_caption__FtNrz"};